import type { ReactNode } from "react";

import { AppNav } from "@/components/app-nav";
import { lead } from "@/components/table";

/**
 * The shell every screen sits in: nav, one column, one heading treatment.
 *
 * `actions` is the right-hand slot on the heading row — a status filter, a
 * checkbox. `intro` is the standing sentence that says what the screen is and,
 * where it matters, what it does not do.
 */
export function Page({
  title,
  intro,
  actions,
  children,
}: {
  title: string;
  intro?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="bg-bg min-h-screen">
      <AppNav />
      <main className="mx-auto max-w-6xl px-6 py-6">
        <div className="flex flex-wrap items-baseline justify-between gap-3">
          <h1 className="font-display text-fg text-lg font-bold">{title}</h1>
          {actions}
        </div>
        {intro ? <p className={lead}>{intro}</p> : null}
        {children}
      </main>
    </div>
  );
}

/** One line of state, worded the same way on every screen. */
export function Notice({
  tone = "muted",
  children,
}: {
  tone?: "muted" | "danger";
  children: ReactNode;
}) {
  return (
    <p className={`mt-6 text-sm ${tone === "danger" ? "text-danger-fg" : "text-fg-muted"}`}>
      {children}
    </p>
  );
}
